module.exports = __webpack_public_path__ + "img/star.3de4f24c.svg";